import { createApp } from "vue"
import SendCalculation from "./SendCalculation"
import { VueReCaptcha } from 'vue-recaptcha-v3'

const el = ".nyk-component--send-calculation"

export default function (Store) {
  const DOM = document.querySelectorAll(el)
  if (DOM.length) {
    DOM.forEach((SendCalculationDOM) => {
      const recaptchaSiteKey = SendCalculationDOM.dataset.recaptchaSiteKey;

      const props = {
        labels: JSON.parse(SendCalculationDOM.dataset.labels),
        formId: SendCalculationDOM.dataset.formId,
        recaptchaSiteKey,
        antiForgeryToken: SendCalculationDOM.dataset.antiForgeryToken,
        formTypeName: SendCalculationDOM.dataset.formTypeName,
        salesforceidApiUrl: SendCalculationDOM.dataset.salesforceidApiUrl,
        sendCalculationApiUrl: SendCalculationDOM.dataset.sendcalculationApiUrl,
        calculatorType: SendCalculationDOM.dataset.calculatorType,
        redirectLink: SendCalculationDOM.dataset.redirectLink
          ? JSON.parse(SendCalculationDOM.dataset.redirectLink)
          : null,
        backgroundColor: SendCalculationDOM.dataset.backgroundColor
      }
      const component = createApp(SendCalculation, props).use(Store)
        .use(Store)
        .use(VueReCaptcha, { siteKey: recaptchaSiteKey })
      component.mount(SendCalculationDOM)
    })
  }
}
